module['exports'] = function(colors) {
  return function(letter, i, exploded) {
    return i % 2 === 0 ? letter : colors.inverse(letter);
  };
};



//////////////////
// WEBPACK FOOTER
// ./~/colors/lib/maps/zebra.js
// module id = ZZ+D
// module chunks = 0